import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { FilePdf, EnvelopeSimple, LinkSimple, CalendarCheck } from "@phosphor-icons/react";
import { api } from "../../lib/api";

const Btn = ({ testid, icon: Icon, children, onClick, busy }) => (
  <button type="button" data-gate-require data-testid={testid} onClick={onClick} disabled={busy}
    className="inline-flex items-center justify-center gap-2 border border-exodus-border bg-exodus-surface px-4 py-3 text-sm hover:border-exodus-gold transition-colors disabled:opacity-50">
    <Icon size={16} className="text-exodus-gold" />{busy ? "Working…" : children}
  </button>
);

export const ExportBar = ({ ensureSaved, bookingUrl }) => {
  const [busy, setBusy] = useState("");
  const wrap = (key, fn) => async () => {
    setBusy(key);
    try { await fn(await ensureSaved()); } catch (e) {
      const d = e?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Something went wrong. Please try again.");
    } finally { setBusy(""); }
  };
  const pdf = wrap("pdf", async (id) => {
    const res = await api.get(`/rollover/scenarios/${id}/pdf`, { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
    const a = document.createElement("a");
    a.href = url; a.download = "exodus-rollover-comparison.pdf"; document.body.appendChild(a); a.click(); a.remove();
    window.URL.revokeObjectURL(url);
    toast.success("Your PDF is downloading.");
  });
  const email = wrap("email", async (id) => { await api.post(`/rollover/scenarios/${id}/email`); toast.success("Sent. Check your inbox for the PDF."); });
  const share = wrap("share", async (id) => {
    const link = `${window.location.origin}/rollover/s/${id}`;
    try { await navigator.clipboard.writeText(link); toast.success("Share link copied."); } catch { window.prompt("Copy your share link:", link); }
  });
  return (
    <div data-testid="ro-export-bar" className="space-y-4">
      <div className="grid sm:grid-cols-3 gap-3">
        <Btn testid="ro-export-pdf" icon={FilePdf} onClick={pdf} busy={busy === "pdf"}>Download PDF</Btn>
        <Btn testid="ro-export-email" icon={EnvelopeSimple} onClick={email} busy={busy === "email"}>Email me the results</Btn>
        <Btn testid="ro-export-share" icon={LinkSimple} onClick={share} busy={busy === "share"}>Copy share link</Btn>
      </div>
      <Link to={bookingUrl || "/reserve"} data-testid="ro-cta-book" className="btn-gold w-full justify-center inline-flex items-center gap-3 py-4">
        <CalendarCheck size={18} /> Schedule an Illustration Review
      </Link>
      <p className="text-[11px] text-exodus-muted text-center">A licensed advisor runs real carrier illustrations against these numbers.</p>
    </div>
  );
};
